<template>
  <div class="icon-picker-wrapper" ref="wrapper">
    <div class="icon-picker-input" @click="togglePicker">
      <span v-if="currentIcon" class="icon-preview">
        <fa-icon :icon="resolveIcon(currentIcon)" />
      </span>
      <span v-else class="icon-placeholder-dot"></span>
      <span class="icon-label">{{ currentLabel }}</span>
      <fa-icon icon="chevron-down" class="icon-chevron" />
    </div>
    <div class="icon-picker-popup" v-if="pickerOpen">
      <div class="icon-picker-header">
        <span class="icon-picker-title">Selecione um icone</span>
        <span
          v-if="currentIcon"
          class="icon-picker-clear"
          @click.stop="clearSelection"
        >Limpar</span>
      </div>
      <div class="icon-picker-grid">
        <div
          v-for="item in icons"
          :key="item.value"
          class="icon-picker-item"
          :class="{ active: currentIcon === item.value }"
          @click.stop="selectIcon(item.value)"
          :title="item.label"
        >
          <fa-icon :icon="resolveIcon(item.value)" class="icon-picker-icon" />
          <span class="icon-picker-item-label">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const PAYMENT_ICONS = [
  { value: "barcode", label: "Boleto" },
  { value: "pix", label: "Pix", prefix: "fab" },
  { value: "qrcode", label: "QR Code" },
  { value: "credit-card", label: "Cartao" },
  { value: "money-check-alt", label: "Cheque" },
  { value: "ticket-alt", label: "Ticket" },
  { value: "dollar-sign", label: "Dollar" },
  { value: "money-bill-wave", label: "Dinheiro" },
  { value: "money-bill-alt", label: "Cedula" },
  { value: "coins", label: "Moedas" },
  { value: "wallet", label: "Carteira" },
  { value: "landmark", label: "Banco" },
  { value: "hand-holding-usd", label: "Recebimento" },
  { value: "cash-register", label: "Caixa" },
  { value: "receipt", label: "Recibo" },
  { value: "file-invoice-dollar", label: "Fatura" },
  { value: "exchange-alt", label: "Transferencia" },
  { value: "link", label: "Link" },
  { value: "percent", label: "Percentual" },
  { value: "shopping-bag", label: "Compra" },
];

const BRAND_ICONS = { pix: true };

export default {
  name: "IconPickerInput",
  props: {
    value: { type: String, default: "" },
  },
  data() {
    return {
      pickerOpen: false,
      icons: PAYMENT_ICONS,
    };
  },
  computed: {
    currentIcon() {
      return this.value || "";
    },
    currentLabel() {
      if (!this.value) return "Nenhum icone";
      const found = this.icons.find((i) => i.value === this.value);
      return found ? found.label : this.value;
    },
  },
  methods: {
    resolveIcon(iconName) {
      if (BRAND_ICONS[iconName]) return ["fab", iconName];
      return iconName;
    },
    togglePicker() {
      this.pickerOpen = !this.pickerOpen;
    },
    selectIcon(iconName) {
      this.$emit("input", iconName);
      this.pickerOpen = false;
    },
    clearSelection() {
      this.$emit("input", "");
      this.pickerOpen = false;
    },
    onDocumentClick(e) {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(e.target)) {
        this.pickerOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.onDocumentClick);
  },
};
</script>

<style scoped>
.icon-picker-wrapper {
  position: relative;
}

.icon-picker-input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  height: 40px;
  border: 1px solid #d8dbe0;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s;
  font-size: 13px;
}

.icon-picker-input:hover {
  border-color: #b0bec5;
}

.icon-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #f2f2f8;
  color: #3a3e81;
  font-size: 13px;
  flex-shrink: 0;
}

.icon-placeholder-dot {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #f0f0f0;
  border: 1px dashed #ccc;
  flex-shrink: 0;
}

.icon-label {
  flex: 1;
  font-size: 13px;
  color: #344054;
}

.icon-chevron {
  font-size: 10px;
  color: #98a2b3;
  flex-shrink: 0;
}

.icon-picker-popup {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 100;
  width: 340px;
  background: #fff;
  border: 1px solid #e4e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  padding: 12px;
}

.icon-picker-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.icon-picker-title {
  font-size: 12px;
  font-weight: 600;
  color: #344054;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.icon-picker-clear {
  font-size: 11px;
  color: #e53e3e;
  cursor: pointer;
  font-weight: 500;
}

.icon-picker-clear:hover {
  text-decoration: underline;
}

.icon-picker-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 6px;
  max-height: 260px;
  overflow-y: auto;
}

.icon-picker-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 4px;
  border: 1px solid #e4e7eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s;
  background: #fff;
}

.icon-picker-item:hover {
  border-color: #3a3e81;
  background: #f2f2f8;
}

.icon-picker-item.active {
  border-color: #3a3e81;
  background: #eceaf3;
}

.icon-picker-icon {
  font-size: 18px;
  color: #344054;
}

.icon-picker-item.active .icon-picker-icon {
  color: #3a3e81;
}

.icon-picker-item-label {
  font-size: 9px;
  color: #667085;
  text-align: center;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon-picker-item.active .icon-picker-item-label {
  color: #3a3e81;
  font-weight: 600;
}
</style>
